import type { Highlight } from '@/modules/Entertainment/interface/Program';
import type { FC } from 'react';
import Link from 'next/link';
import { Flex, Text } from '@eqi-investimentos/react';
import { Box, Image } from '@chakra-ui/react';
import { PATHS } from '@/config/paths';
import { IfRender } from '@/utils/jsx';
export const MostViewedCard: FC<MostViewedCardProps> = ({
  programType,
  slug,
  thumb,
  title,
  type,
  category,
  hideCategory = false
}) => {
  return <Flex as={Link} href={getCardHref({
    type,
    programType,
    slug
  })} passHref flexDir="row" w="21.75rem" maxW="21.75rem" h="7.75rem" p="l" gap="s" bg="background.brandLight" borderRadius="0.5rem" data-sentry-element="Flex" data-sentry-component="MostViewedCard" data-sentry-source-file="Card.tsx">
      <Box w="5.25rem" h="5.25rem" data-sentry-element="Box" data-sentry-source-file="Card.tsx">
        <Image src={thumb} alt={title} w="5.25rem" h="5.25rem" objectFit="cover" borderRadius="lg" data-sentry-element="Image" data-sentry-source-file="Card.tsx" />
      </Box>
      <Flex flexDir="column" justifyContent="center" alignItems="left" w="full" maxW="13.25rem" gap="4" data-sentry-element="Flex" data-sentry-source-file="Card.tsx">
        <IfRender condition={!hideCategory && !!category} data-sentry-element="IfRender" data-sentry-source-file="Card.tsx">
          <Text fontSize="sm" fontWeight="light" color="content.brand" data-sentry-element="Text" data-sentry-source-file="Card.tsx">
            {category}
          </Text>
        </IfRender>
        <Text fontSize="sm" fontWeight="normal" color="content.primary" noOfLines={2} data-sentry-element="Text" data-sentry-source-file="Card.tsx">
          {title}
        </Text>
      </Flex>
    </Flex>;
};
const getCardHref = ({
  programType,
  slug,
  type
}: {
  type: Highlight['type'];
  programType: Highlight['program_type'];
  slug: string;
}) => {
  if (type === 'content') {
    return `${PATHS.hubs.content}/${slug}`;
  }
  if (programType === 'recommendation') {
    return `${PATHS.hubs.researchProgram}/${slug}`;
  }
  return `${PATHS.hubs[type]}/${slug}`;
};
type MostViewedCardProps = Pick<Highlight, 'thumb' | 'title' | 'type'> & {
  programType: Highlight['program_type'];
  slug: Highlight['id'];
  category?: string;
  type?: string;
  hideCategory?: boolean;
};